module.exports = __webpack_public_path__ + "static/media/img23.6998c19b.jpg";